import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "./customBaseQuery";
import { gql } from "graphql-request";
import { PidApiUserType } from "@lxp-app/pages/event-review/Utils/pidApiUserType";

export const UserUtility = createApi({
  reducerPath: "userUtility",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  tagTypes: ["userdata"],
  endpoints: (builder) => ({
    getuser: builder.query({
      query: ({
        pageNumber,
        pageSize,
        sortKey,
        sortOrder,
        data
      }: PidApiUserType) => ({
        url: `/pid/profile/detail/paginated/enable-ignored`,
        method: "POST",
        params: {
          pageNumber: pageNumber || 1,
          pageSize: pageSize || 6,
          sortKey: sortKey || "createdat",
          sortOrder: sortOrder || "DESC"
        },
        body: data
      }),
      extraOptions: { service: "PID" }
    }),
    getUserByIdsForLP: builder.query({
      query: ({ ids }): any => ({
        body: gql`
          query GetProfileByIdIn($userIds: [String]!) {
            getProfileByIdIn(userIds: $userIds) {
              data {
                profiles {
                  id
                  name {
                    fullName
                    lastName
                    firstName
                  }
                  employment {
                    designation
                  }
                  email
                  profileImageUrl
                }
              }
            }
          }
        `,
        params: {
          variables: {
            userIds: ids
          }
        },
        url: "/graphql"
      }),
      extraOptions: { service: "PID" }
    })
  })
});

export const {
  useGetuserQuery,
  useLazyGetuserQuery,
  useGetUserByIdsForLPQuery,
  useLazyGetUserByIdsForLPQuery
} = UserUtility;
